/**
 * CredentialsForm Component
 * Step 2: Enter credentials (routes to type-specific forms)
 */

import React from 'react';
import { OdooForm } from './forms/OdooForm';
import { SalesforceForm } from './forms/SalesforceForm';
import { SAPForm } from './forms/SAPForm';

type DatasourceType = 'salesforce' | 'sap_erp' | 'odoo';

interface CredentialsFormProps {
  type: DatasourceType;
  initialValues: Record<string, any>;
  onSubmit: (credentials: Record<string, any>) => void;
  onBack: () => void;
}

export const CredentialsForm: React.FC<CredentialsFormProps> = ({
  type,
  initialValues,
  onSubmit,
  onBack,
}) => {
  const renderForm = () => {
    switch (type) {
      case 'odoo':
        return (
          <OdooForm
            initialValues={initialValues}
            onSubmit={onSubmit}
            onBack={onBack}
          />
        );
      case 'salesforce':
        return (
          <SalesforceForm
            initialValues={initialValues}
            onSubmit={onSubmit}
            onBack={onBack}
          />
        );
      case 'sap_erp':
        return (
          <SAPForm
            initialValues={initialValues}
            onSubmit={onSubmit}
            onBack={onBack}
          />
        );
      default:
        return null;
    }
  };

  return <div>{renderForm()}</div>;
};
